module.exports = __webpack_public_path__ + "img/status-request.a2615e1f.svg";